"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTICALL_NETWORKS = exports.MULTICALL_ABI = exports.ChainId = void 0;
// import { ChainId } from '@uniswap/sdk'
const abi_json_1 = __importDefault(require("./abi.json"));
exports.MULTICALL_ABI = abi_json_1.default;
var ChainId;
(function (ChainId) {
    ChainId[ChainId["MAINNET"] = 1] = "MAINNET";
    ChainId[ChainId["ROPSTEN"] = 3] = "ROPSTEN";
    ChainId[ChainId["RINKEBY"] = 4] = "RINKEBY";
    ChainId[ChainId["KOVAN"] = 42] = "KOVAN";
    ChainId[ChainId["BSCTest"] = 97] = "BSCTest";
    ChainId[ChainId["BSC"] = 56] = "BSC";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
const MULTICALL_NETWORKS = {
    [ChainId.MAINNET]: "0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441",
    [ChainId.ROPSTEN]: "0x53C43764255c17BD724F74c4eF150724AC50a3ed",
    [ChainId.KOVAN]: "0x2cc8688C5f75E365aaEEb4ea8D6a480405A48D2A",
    [ChainId.RINKEBY]: "0x42Ad527de7d4e9d9d011aC45B31D8551f8Fe9821",
    [ChainId.BSCTest]: "0xae11C5B5f29A6a25e955F0CB8ddCc416f522AF5C",
    [ChainId.BSC]: "0x41263cba59eb80dc200f3e2544eda4ed6a90e76c",
};
exports.MULTICALL_NETWORKS = MULTICALL_NETWORKS;
